
import { Link } from 'react-router-dom';

export default function PurposeRecommend() {
  const purposes = [
    {
      id: 'free',
      title: '年会費無料',
      description: 'コストをかけずにカードを持ちたい方に',
      icon: 'ri-price-tag-3-line',
      color: 'from-emerald-500 to-teal-600',
      bgColor: 'from-emerald-50 to-teal-50',
      link: '/free',
      features: ['維持費ゼロ', '初心者向け', '複数枚持ちOK']
    },
    {
      id: 'instant',
      title: '即日発行',
      description: '今すぐカードが必要な方に',
      icon: 'ri-flashlight-line',
      color: 'from-rose-500 to-pink-600',
      bgColor: 'from-rose-50 to-pink-50',
      link: '/instant',
      features: ['最短即日', 'ネット申込', 'すぐ使える']
    },
    {
      id: 'student',
      title: '学生向け',
      description: '学生限定の特典が充実したカード',
      icon: 'ri-graduation-cap-line',
      color: 'from-sky-500 to-cyan-600',
      bgColor: 'from-sky-50 to-cyan-50',
      link: '/student',
      features: ['学生限定特典', '審査通りやすい', '将来に備える']
    }
  ];

  return (
    <section className="py-12 sm:py-16 md:py-20 lg:py-24 bg-gradient-to-b from-white to-gray-50">
      <div className="max-w-6xl mx-auto px-4 sm:px-6">
        {/* ヘッダー */}
        <div className="text-center mb-8 sm:mb-12 md:mb-16">
          <span className="inline-flex items-center gap-2 bg-gradient-to-r from-teal-100 to-emerald-100 text-teal-700 px-4 sm:px-5 py-2 rounded-full text-xs sm:text-sm font-bold mb-4 sm:mb-6 shadow-sm">
            <i className="ri-focus-3-line text-base sm:text-lg"></i>
            目的別で探す
          </span>
          <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 mb-3 sm:mb-5 tracking-tight px-4">
            目的別
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-teal-600 to-emerald-600">おすすめカード</span>
          </h2>
          <p className="text-sm sm:text-base md:text-lg text-gray-500 max-w-2xl mx-auto px-4">
            あなたの目的に合ったクレジットカードを見つけましょう
          </p>
        </div>

        {/* カードグリッド */}
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4 sm:gap-6 md:gap-8">
          {purposes.map((purpose) => (
            <Link
              key={purpose.id}
              to={purpose.link}
              className="group block"
            >
              <div className={`relative bg-gradient-to-br ${purpose.bgColor} rounded-2xl sm:rounded-3xl p-5 sm:p-6 md:p-8 h-full transition-all duration-500 hover:shadow-2xl hover:-translate-y-1 sm:hover:-translate-y-2 border border-gray-100 hover:border-transparent overflow-hidden`}>
                {/* 装飾 */}
                <div className={`absolute top-0 right-0 w-24 sm:w-32 h-24 sm:h-32 bg-gradient-to-br ${purpose.color} opacity-10 rounded-full blur-2xl group-hover:opacity-20 transition-opacity`}></div>
                
                {/* アイコン */}
                <div className={`w-12 h-12 sm:w-14 sm:h-14 md:w-16 md:h-16 bg-gradient-to-br ${purpose.color} rounded-xl sm:rounded-2xl flex items-center justify-center mb-4 sm:mb-5 md:mb-6 shadow-lg group-hover:scale-105 sm:group-hover:scale-110 transition-transform duration-300`}>
                  <i className={`${purpose.icon} text-white text-xl sm:text-2xl md:text-3xl`}></i>
                </div>

                {/* タイトル */}
                <h3 className="text-lg sm:text-xl md:text-2xl font-bold text-gray-900 mb-2 sm:mb-3 group-hover:text-teal-600 transition-colors">
                  {purpose.title}
                </h3>

                {/* 説明 */}
                <p className="text-gray-600 text-sm sm:text-base mb-4 sm:mb-6">
                  {purpose.description}
                </p>

                {/* 特徴タグ */}
                <div className="flex flex-wrap gap-1.5 sm:gap-2 mb-4 sm:mb-6">
                  {purpose.features.map((feature, idx) => (
                    <span
                      key={idx}
                      className="inline-block bg-white/80 text-gray-700 text-xs sm:text-sm font-medium px-2.5 sm:px-4 py-1.5 sm:py-2 rounded-lg sm:rounded-xl shadow-sm"
                    >
                      {feature}
                    </span>
                  ))}
                </div>

                {/* リンク */}
                <div className="flex items-center gap-2 text-teal-600 font-bold group-hover:gap-3 transition-all text-sm sm:text-base">
                  <span>詳しく見る</span>
                  <i className="ri-arrow-right-line text-base sm:text-lg"></i>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
